<template>
  <v-container>
    <div class="page">
    <div class="section">
      <div class="title">
        Databases to support ExposomeX platform:
      </div>
      <v-divider class="line"></v-divider>
      <div v-for="(item, index) in databases" :key="index">
        <div class="item-context">
          <span class="name-span cursor">{{item.name}}</span>
          <v-btn variant="tonal" color="info" class="mr-2" size="x-small" @click="goDownloadDetailPage(item.router)">Download Details</v-btn>
        </div>
        <v-divider class="line"></v-divider>
      </div>
    </div>

    </div>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      databases: [{
        name: 'Version 1.0.0',
        router: '/database-version-100'
      },{
        name: 'Version 1.0.1',
        router: '/database-version-101'
      }],
      demoData: [{
        name: 'Version 1.0.0',
        router: '/demo-data-version-100'
      },{
        name: 'Version 1.0.1',
        router: '/demo-data-version-101'
      }]
    };
  },
  methods: {
    goDownloadDetailPage(url) {
      this.$router.push(url);
    }
  },
};
</script>
<style scoped lang="scss">
.page {
  margin-left: 2em;
}
.section {
  font-size: $webpage-large-font-size;
  margin-right: 20em;
}
.title {
  font-weight: 600;
  margin: 1em 0 0.6em;
}
.item-context {
  display: flex;
  align-items: center;
  font-size: $webpage-base-font-size;
  line-height: 1.6;
  margin: 0.2em 0;
  justify-content: start;
}
.name-span {
  width: 10em;
  flex-shrink: 0;
}
.line {
  width: 90%;
}

@media screen and (min-width: 601px) and (max-width: 1280px) {
  .line {
    width: 100%;
  }
  .section {
    margin-right: 10em;
  }
}
@media screen and (max-width: 600px) {
  .line {
    width: 100%;
  }
  .name-span {
    width: 8em;
  }
  .section {
    margin: 0;
  }
}
</style>
